import classNames from 'classnames';
import React, { useState, useEffect, useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ReactComponent as BackArrowIcon } from '../../assets/icons/BackArrowIcon.svg';
import { State } from '../../contexts/GlobalState';
import variables from '../../theme/variables';
import SecondaryGallery from './SecondaryGallery';
import SecondaryImage from './SecondaryImage';
import SecondaryText from './SecondaryText';
import SecondaryVideo from './SecondaryVideo';
import SecondaryAudio from './SecondaryAudio';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'relative',
            top: 0,
            left: 0,
            width: '100%',
            minHeight: 'var(--app-height)',
            transition: 'opacity 0.5s ease-in-out',
            zIndex: 3000,
            padding: '218px 32px 0',
            display: 'flex',

            '@media (min-width: 860px)': {
                paddingTop: 115,
            },
        },

        background: {
            width: '120vw',
            height: '120vh',
            position: 'fixed',
            top: '-10vh',
            left: '-10vw',
            zIndex: -1,
            backgroundColor: `rgba(0, 0, 0, 0.8)`,
        },

        inner: {
            // position: 'relative',
            width: '100%',
            maxWidth: 860,
            margin: '0 auto',
            color: variables.palette.white,

            '@media (min-width: 1024px)': {
                position: 'relative',
            },
        },

        closeBtnWrap: {
            position: 'absolute',
            height: 'calc(100% - 100px)',
            left: 14,
            top: 21 + variables.msftHeaderHeightMobile,

            '@media (min-width: 860px)': {
                top: 21 + variables.msftHeaderHeight,
            },

            '@media (min-width: 1024px)': {
                left: 60,
                top: 45 + variables.msftHeaderHeight,
            },
        },
        closeBtn: {
            position: 'sticky',
            left: 14,
            top: 21,

            '@media (min-width: 860px)': {
                top: 21 + variables.msftHeaderHeight,
            },

            '@media (min-width: 1024px)': {
                left: 60,
                top: 45,
            },

            background: 'rgba(255, 255, 255, 0.16)',
            border: '1px solid #CCCCCC',
            backdropFilter: 'blur(76px)',
            borderRadius: 8,
            color: variables.palette.white,
            fontSize: 18,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px',
            height: 52,
            cursor: 'pointer',
            zIndex: 3000,

            '& svg': {
                marginRight: 8,
            },
        },
    },
    { name: 'SecondaryHotspot' }
);

export default function SecondaryHotspot({ onClose, hotspot }) {
    const classes = useStyles();

    const [state, setState] = useState('init'); // init, in, leave
    const { returnButtonTheme } = useContext(State);

    useEffect(() => {
        setTimeout(() => setState('in'), 1);
    }, []);

    const handleClose = () => {
        setState('leave');
        setTimeout(onClose, 510);
    };

    return (
        <div
            className={classNames(classes.wrap)}
            style={{
                opacity: state === 'in' ? 1 : 0,
            }}
        >
            <div className={classes.closeBtnWrap}>
                <button
                    className={classes.closeBtn}
                    onClick={handleClose}
                    style={{ ...returnButtonTheme }}
                >
                    <BackArrowIcon />
                    &nbsp;Studio
                </button>
            </div>
            <div className={classes.background}></div>
            <div className={classes.inner}>
                {/* <button className={classes.closeBtn} onClick={handleClose}>
                    <CloseIcon width="100%" height="100%" />
                </button> */}

                {hotspot.type === 'text' && (
                    <SecondaryText hotspot={hotspot} state={state} />
                )}
                {hotspot.type === 'image' && (
                    <SecondaryImage hotspot={hotspot} state={state} />
                )}
                {hotspot.type === 'video' && (
                    <SecondaryVideo hotspot={hotspot} state={state} />
                )}
                {hotspot.type === 'gallery' && (
                    <SecondaryGallery hotspot={hotspot} state={state} />
                )}
                {hotspot.type === 'audio' && (
                    <SecondaryAudio hotspot={hotspot} state={state} />
                )}
            </div>
        </div>
    );
}
